// Bootstrap Custom File Input
import bsCustomFileInput from 'bs-custom-file-input'

document.addEventListener('turbolinks:load', () => {
  bsCustomFileInput.init()
})
